"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var vuex_1 = require("vuex");
var EmbeddedInput_vue_1 = require("./components/EmbeddedInput.vue");
var EmbeddedConfirm_vue_1 = require("./components/EmbeddedConfirm.vue");
var EmbeddedComplete_vue_1 = require("./components/EmbeddedComplete.vue");
var AppContactEmbedded = /** @class */ (function (_super) {
    tslib_1.__extends(AppContactEmbedded, _super);
    function AppContactEmbedded() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppContactEmbedded.prototype.created = function () {
        // 埋め込み用画面であることをStoreに設定
        this.$store.commit('setEmbedded', true);
        this.$store.dispatch('init');
    };
    AppContactEmbedded = tslib_1.__decorate([
        vue_property_decorator_1.Component({
            components: {
                Embedded_inputForm: EmbeddedInput_vue_1.default,
                Embedded_confirmForm: EmbeddedConfirm_vue_1.default,
                Embedded_completeForm: EmbeddedComplete_vue_1.default
            },
            computed: tslib_1.__assign(tslib_1.__assign({}, vuex_1.mapState([
                'progress',
                'isEmbedded'
            ])), vuex_1.mapGetters([
                'currentProgress'
            ])),
            methods: tslib_1.__assign({}, vuex_1.mapMutations([
                'setAgreePrivacyPolicy',
                'setType',
                'progressNext',
                'setEmbedded'
            ]))
        })
    ], AppContactEmbedded);
    return AppContactEmbedded;
}(vue_property_decorator_1.Vue));
exports.default = AppContactEmbedded;
